"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("./styles");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Panel = (0, _react.memo)(({
  title = '',
  showHeader = false,
  hasConnector = false,
  isPopup = false,
  children,
  onClose = () => {},
  hasCloseBtn = false,
  className
}) => _react.default.createElement(_styles.SPanel, {
  hasConnector: hasConnector,
  className: className
}, showHeader && _react.default.createElement(_styles.SHeader, null, _react.default.createElement(_styles.SHeaderTitle, {
  title: title
}, title), hasCloseBtn && _react.default.createElement(_styles.SCloseIcon, {
  onClick: onClose
})), _react.default.createElement(_styles.SBody, {
  isPopupContainer: isPopup
}, children)));
Panel.propTypes = {
  title: _propTypes.default.string,
  showHeader: _propTypes.default.bool,
  hasConnector: _propTypes.default.bool,
  isPopup: _propTypes.default.bool,
  onClose: _propTypes.default.func,
  hasCloseBtn: _propTypes.default.bool,
  children: _propTypes.default.node
};
var _default = exports.default = Panel;